import { isFunction } from 'lodash';

import { getGa } from 'core/googleAnalytics';
type EventCategory = 'VENUE_NAVIGATION_BAR';

export type NavigationBarEventAction =
  | 'OPEN_INSIGHTS'
  | 'OPEN_INSIGHTS_V2'
  | 'OPEN_INSIGHTS_V2_PERFORMANCE'
  | 'OPEN_INSIGHTS_V2_OPERATIONS'
  | 'OPEN_INSIGHTS_V2_CUSTOMER_BASE'
  | 'OPEN_INSIGHTS_V2_MENU'
  | 'OPEN_INSIGHTS_V2_RATINGS_AND_REVIEWS'
  | 'OPEN_INSIGHTS_V2_REJECTIONS'
  | 'OPEN_MENU_EDITOR'
  | 'OPEN_PROMOTIONS'
  | 'OPEN_PICKING_ROUTE'
  | 'OPEN_VENUE_DETAILS'
  | 'OPEN_LIVE_PURCHASES'
  | 'OPEN_PURCHASES'
  | 'OPEN_PURCHASES_V2'
  | 'OPEN_PURCHASES_HISTORY'
  | 'OPEN_SETTLEMENTS'
  | 'OPEN_PAYOUT_REPORTS'
  | 'OPEN_ACCESS_MANAGEMENT'
  | 'OPEN_TRANSLATION'
  | 'OPEN_CAMPAIGNS'
  | 'OPEN_BEST_OF_WOLT';

type NavigationPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: NavigationBarEventAction;
  eventLabel?: string;
};

const report = (payload: NavigationPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportOpenNavigationItem = (eventAction: NavigationBarEventAction) => {
  report({
    hitType: 'event',
    eventCategory: 'VENUE_NAVIGATION_BAR' as EventCategory,
    eventAction,
  });
};
